import { EMAIL_REGEX } from 'utils/regex';

const _locale = require('yup/lib/locale');
const _string = require('yup/lib/string');

// override for yup validation of email with custom regex
_string.prototype.email = function email(message) {
  return this.matches(EMAIL_REGEX, {
    message: message === void 0 ? _locale.string.email : message,
    excludeEmptyString: true
  });
};



// WEBPACK FOOTER //
// ./src/overrides.js